export default function StatCard({ label, value, tone = 'primary', hint }) {
  const toneClasses = {
    primary: 'from-blue-300/18 to-blue-300/8 text-blue-100',
    success: 'from-emerald-300/18 to-emerald-300/8 text-emerald-100',
    warning: 'from-amber-300/18 to-amber-300/8 text-amber-100',
    neutral: 'from-white/8 to-white/[0.03] text-slate-100'
  };

  return (
    <div className={`rounded-[16px] border border-white/8 bg-gradient-to-br p-3 shadow-[0_8px_22px_rgba(3,8,20,0.16)] ${toneClasses[tone] || toneClasses.primary}`}>
      <p className="text-xs uppercase tracking-[0.16em] text-slate-400">{label}</p>
      <p className="mt-2 text-xl font-semibold tracking-tight">{value}</p>
    </div>
  );
}
